import * as React from 'react';

import { Acknowledgment as DocumentsAcknowledgementDialog } from './documents/acknowledgment';

export const DialogManager: React.FC = () => <DocumentsAcknowledgementDialog />;
